export { default as ReferralGiverAmount } from './ReferralGiverAmount/ReferralGiverAmount';
export { default as ShareReferralCode } from './ShareReferralCode/ShareReferralCode';
export { default as ReferralsHowItWorks } from './ReferralsHowItWorks/ReferralsHowItWorks';
